import copyToClipboard from 'copy-to-clipboard';
import { useCallback } from 'react';

import Button from '~components/generic/elements/Button';
import useAppDispatch from '~hooks/useAppDispatch';
import { convertToRawValue } from '~services/data-conversion';
import { StatusActions } from '~store/actions';

export default function CopyToClipboardButton({ code }: { code: string }) {
  const dispatch = useAppDispatch();
  const cleanData = convertToRawValue(code);
  const handleClick = useCallback(() => {
    const isCopied = copyToClipboard(cleanData);
    if (isCopied) {
      dispatch(StatusActions.setSuccessNotification('Copied source code!'));
    }
  }, [cleanData, dispatch]);

  return (
    <Button
      className="u-size-xs c-button c-button--light u-margin-left-md u-padding-horizontal-md"
      name="ui-component-code-copy"
      label="Copy source code to clipboard"
      title="Copy source code to clipboard"
      hideLabel={true}
      iconName="copy-to-clipboard"
      iconCentered={false}
      onClick={handleClick}
    />
  );
}
